import { z } from 'zod'

import { accountModel } from '@/common/models/account'

export const accountSubject = z.tuple([
  z.union([
    z.literal('create'),
    z.literal('edit'),
    z.literal('inactivate'),
    z.literal('manage_applications'),
  ]),
  z.union([z.literal('Account'), accountModel]),
])

export type AccountSubject = z.infer<typeof accountSubject>
